import { AppointmentStatus } from '@shared/generated/graphql';
import { StopType } from 'clerk_common/types/stop';
import moment from 'moment-timezone';

export function notYetScheduledOrUnknown(status?: AppointmentStatus) {
  if (!status) return true;
  if (status == AppointmentStatus.NEW) return true;
  if (status == AppointmentStatus.REQUESTED) return false;
  if (status == AppointmentStatus.CONFIRMED) return false;
  return true;
}

export function knownAndInProgress(status?: AppointmentStatus) {
  if (!status) return false;
  if (status == AppointmentStatus.REQUESTED) return true;
  if (status == AppointmentStatus.CONFIRMED) return true;
  return false;
}

export function getDefaulTime(type: StopType): string {
  switch (type) {
    case 'PICKUP':
      return '13:00';
    case 'DELIVERY':
      return '09:00';
    default:
      return '';
  }
}

export function formatTime(dt: Date, tz: string) {
  return moment.tz(dt, tz).format('HH:mm');
}

export function formatParsedTime(parsedTime: {
  hours: number;
  minutes: number;
}) {
  return `${parsedTime.hours.toString().padStart(2, '0')}:${parsedTime.minutes
    .toString()
    .padStart(2, '0')}`;
}

export function createDateTime(
  day: string,
  time: { hours: number; minutes: number },
  timezone: string
): Date {
  const momentDate = moment.tz(
    `${day} ${time.hours}:${time.minutes}`,
    'YYYY-MM-DD HH:mm',
    timezone
  );
  return momentDate.toDate();
}
